import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { experimentalStyled } from "@material-ui/core";
import DashboardNavbar from "./DashboardNavbar";
import DashboardSidebar from "./DashboardSidebar";
import useProcedureManagement from "../hooks/useProcedureManagement";
import useCreditManagement from "../hooks/useCreditManagement";

const DashboardLayoutRoot = experimentalStyled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  display: "flex",
  height: "100%",
  // overflowX: 'hidden',
  width: "100%"
}));

const DashboardLayoutWrapper = experimentalStyled("div")(({ theme }) => ({
  display: "flex",
  flex: "1 1 auto",
  // overflowX: 'hidden',
  paddingTop: 64,
  [theme.breakpoints.up("lg")]: {
    paddingLeft: 256
  }
}));

const DashboardLayoutContainer = experimentalStyled("div")({
  display: "flex",
  flex: "1 1 auto"
  // overflowX: 'hidden'
});

const DashboardLayoutContent = experimentalStyled("div")({
  flex: "1 1 auto",
  height: "100%"
  // overflow: 'auto'
});

const DashboardLayout = () => {
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const {
    listOnTime,
    getContractOnTime,
    listDelay,
    getContractDelay
  } = useProcedureManagement();

  const {
    listOnTime: listOnTimeCredit,
    getCreditOnTime,
    listDelay: listDelayCredit,
    getCreditDelay
  } = useCreditManagement();
  useEffect(() => {
    getContractOnTime();
    getContractDelay();
    getCreditOnTime();
    getCreditDelay();
  }, []);

  return (
    <DashboardLayoutRoot>
      <DashboardNavbar
        onMobileNavOpen={() => setMobileNavOpen(true)}
        listOnTime={listOnTime}
        listDelay={listDelay}
        listOnTimeCredit={listOnTimeCredit}
        listDelayCredit={listDelayCredit}
      />
      <DashboardSidebar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <DashboardLayoutWrapper>
        <DashboardLayoutContainer>
          <DashboardLayoutContent>
            <Outlet />
          </DashboardLayoutContent>
        </DashboardLayoutContainer>
      </DashboardLayoutWrapper>
    </DashboardLayoutRoot>
  );
};

export default DashboardLayout;
